import {Button, Dialog, DialogActions, DialogTitle} from "@mui/material";
import React, {useState} from "react";
import {LoadingButton} from "@mui/lab";

interface AgreeDialogProps {
    onDelete: () => void;
    children: (handleOpen: () => void, handleClose: () => void) => React.ReactNode;
    text: string;
}

const AgreeDialog = ({onDelete, children, text}: AgreeDialogProps) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [processing, setProcessing] = useState<boolean>(false);
    const open = () => {
        setDialogOpen(true);
    }

    const close = () => {
        setDialogOpen(false);
    }

    const handleDeleteClick = async () => {
        if (onDelete) {
            setProcessing(true);
            await onDelete();
            setProcessing(false);
        }
        close();
    };
    return (
            <>
                {typeof children === 'function' ? children(open, close) : children}
                <Dialog
                        open={dialogOpen}
                        onClose={close}
                >
                    <DialogTitle id="alert-dialog-title">
                        {text}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={close} color={"error"}>No</Button>
                        <LoadingButton onClick={handleDeleteClick} autoFocus loading={processing}>
                            Yes
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </>
    )
}

export default AgreeDialog;